import React from "react"
import styled from "styled-components"
import { MainButton } from "../../styles/buttons"
import useInView from "react-cool-inview"
import { useSetRecoilState } from "recoil"
import {
    activeFormImage,
    showingRomanceForm,
    showingWeddingForm,
} from "../../state/atoms"

const Container = styled.div`
    margin-bottom: 160px;
    display: grid;
    grid-template-columns: 50% 50%;
    column-gap: 5%;
    padding: 20px;

    margin-top: -200px;
    padding-top: 200px;

    @media (max-width: 750px) {
        padding: 0;
        margin-top: -140px;
        padding-top: 140px;
        grid-template-columns: 100%;
        margin-bottom: ${props => (!props.last ? "80px" : "30px")};
    }
`
const ImageContainer = styled.div`
    order: ${props => (props.odd ? 1 : 0)};

    @media (max-width: 750px) {
        order: 0;
    }
`
const Image = styled.img``
const Content = styled.div`
    flex: 1;
    padding: 20px;
`
const Title = styled.h2`
    text-transform: uppercase;
    font-size: 50px;
    margin-bottom: 40px;

    @media (max-width: 750px) {
        font-size: 35px;
    }
`
const Description = styled.p`
    font-size: 18px;
    line-height: 1.4;
    width: 45ch;

    @media (max-width: 750px) {
        font-size: 16px;
        width: 100%;
        max-width: 50ch;
        margin-bottom: 30px;
    }

    @media (max-width: 550px) {
        text-align: left;
    }
`
const RomanceItem = ({ item, odd, setCurrentSection }) => {
    const showWeddingForm = useSetRecoilState(showingWeddingForm)
    const showRomanceForm = useSetRecoilState(showingRomanceForm)
    const setActiveImage = useSetRecoilState(activeFormImage)

    const { ref } = useInView({
        // Shrink the root margin, so the animation will be triggered once the target reach a fixed amount of visible
        threshold: 0.5,
        onEnter: () => {
            setCurrentSection(`#${item.id}`)
        },
    })

    return (
        <Container id={item.id} ref={ref}>
            <ImageContainer odd={odd}>
                <Image src={item.image.sourceUrl} />
            </ImageContainer>
            <Content>
                <Title>{item.title}</Title>
                <Description>{item.description}</Description>
                <MainButton
                    onClick={() => {
                        if (item.type === "Wedding") {
                            setActiveImage(item.image.sourceUrl)
                            showWeddingForm(true)
                        } else {
                            setActiveImage(item.image.sourceUrl)
                            showRomanceForm(true)
                        }
                    }}
                >
                    Request a Quote
                </MainButton>
            </Content>
        </Container>
    )
}

export default RomanceItem
